import React from 'react';
import { updateInvestorBasicInformationMutation } from '../../../apollo';
import BasicInformationForm from './BasicInformationForm';
import AccountForm from '../AccountForm';

const BasicInformation = (props) => (
  <AccountForm
    Form={BasicInformationForm}
    mutation={updateInvestorBasicInformationMutation}
    {...props}
  />
);

export default BasicInformation;



// WEBPACK FOOTER //
// ./src/components/Account/BasicInformation/index.js